import React from 'react';
import { components, OptionProps } from 'react-select';

export const CheckboxOption: React.FC<OptionProps> = (props: OptionProps) => {
  return (
    <components.Option {...props}>
      <div className="rds-checkbox">
        <input
          name={props.selectProps.name}
          type="checkbox"
          checked={props.isSelected}
          //this onchange never triggers
          onChange={(event) => console.log('on change', event.target.value)}
        />
        <span className="rds-checkmark is-white-labeled-primary-color" />
        <span className="rds-checkbox-text has-text-nowrap">{props.label}</span>
      </div>
    </components.Option>
  );
};

export const RadioOption: React.FC<OptionProps> = (props: OptionProps) => {
  return (
    <components.Option {...props}>
      <div className="rds-radio">
        <input
          name={props.selectProps.name}
          type="radio"
          checked={props.isSelected}
          //this onchange never triggers
          onChange={(event) => console.log('on change', event.target.value)}
          aria-label={props.selectProps.name}
        />
        <span className="rds-radio-icon is-white-labeled-primary-color" />
        <span className="has-text-nowrap">{props.label}</span>
      </div>
    </components.Option>
  );
};

export const Option = (props: any) => {
  return props.selectProps.isMulti ? (
    <CheckboxOption {...props} />
  ) : (
    <RadioOption {...props} />
  );
};
